import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Box from "components/UI/Box";
import AmenitiesAddModal from "./AmenitiesAddModal";
import Edit from "./Edit";
import View from "./View";
import GymNavigation from "../GymNavigation";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, ERROR_HANDLE } from "config/constants";

const PRIMARY_AMENITIES_CLASS_ID = 0
const CLASSES_TEXT = "classes"
const CLASS_ID_KEY = "class_id"

const style = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "900px"
  }
};

class Amenities extends React.Component {
  state = {
    gymid: this.props.gymid,
    gymAmenities: [],
    allAmenities: [],
    modal: false,
    filteredAmenities: [],
    isPrimaryAmenity: false
  };

  componentDidMount() {
    if (this.props.gymid) {
      this.getAmenities();
      this.getAllAmenities();
    }
  }

  getAmenities() {
    const { gymid } = this.state;
    const toastId = toast("Fetching Amenities Data...");
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/gyms/amenities/${gymid}`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          gymAmenities: this.updatePrimaryAmenitiesId(res.data)
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  getAllAmenities() {
    // const toastId = toast("Fetching All Amenities...");
    const access_token = localStorage.getItem("access_token");
    axios
      .get(`${API_URL}/gyms/amenities/icons`, {
        headers: {
          "x-access-token": access_token
        }
      })
      .then(res => {
        this.setState({
          ...this.state,
          allAmenities: res.data
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  updatePrimaryAmenitiesId(amenities) {
    const updatedAmenities = amenities.map(
      amenity => amenity.hasOwnProperty(CLASS_ID_KEY) ? {...amenity, is_primary_amenity : false} : {...amenity, class_id: PRIMARY_AMENITIES_CLASS_ID, is_primary_amenity : true}
    );
    //sort updatedAmenities based on the classId
    return updatedAmenities.sort((a, b) => { return a.class_id - b.class_id });
  }

  deleteAmenitiy = (amenityid, isPrimaryAmenity) => {
    const { gymid } = this.state;
    const toastId = toast("Removing Amenity...");
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/gyms/amenities/remove/${gymid}`,
        { amenity: amenityid,
          is_primary_amenity: isPrimaryAmenity
        },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          gymAmenities: this.updatePrimaryAmenitiesId(res.data)
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  addAmenitiy = amenities => {
    this.setState({ modal: false });
    const { gymid, isPrimaryAmenity } = this.state;
    const toastId = toast("Adding Amenities...");
    const access_token = localStorage.getItem("access_token");
    axios
      .post(
        `${API_URL}/gyms/amenities/add/${gymid}`,
        { 
          amenities,
          is_primary_amenity: isPrimaryAmenity
         },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        this.setState({
          ...this.state,
          gymAmenities: this.updatePrimaryAmenitiesId(res.data),
          isPrimaryAmenity: false
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  };

  getClassesAndConditionsAmenities() {
    let amenities = this.state.allAmenities.filter(amenity => new RegExp(CLASSES_TEXT, "i").test(amenity.class_name));
    return amenities.length > 0 ? amenities[0].amenities : []
  }

  addBtn = (classid, isPrimaryAmenity) => {
    const allAmenities = this.state.allAmenities[classid - 1];
    const gym = this.state.gymAmenities[classid].amenities;
    const all = allAmenities ? allAmenities.amenities : this.getClassesAndConditionsAmenities();
    const filteredAmenities = all.filter(
      i => (gym.filter(x => x.id === i.id).length ? false : true)
    );
    this.setState({ modal: true, filteredAmenities, isPrimaryAmenity });
  };

  render() {
    return (
      <React.Fragment>
        {this.state.modal && (
          <AmenitiesAddModal
            isPrimaryAmenity = {this.state.isPrimaryAmenity}
            data={this.state.filteredAmenities}
            add={this.addAmenitiy}
          />
        )}
        {/* <DialogueOverlay>
          <div
            style={{
              width: "70vw",
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)"
            }}
          >
            <AmenityBox label={"Add Item"} />
            <AmenityBox label={"Add Item"} />
          </div>
          <div style={{ width: "10vw", margin: "auto" }}>
            <Button type="primary" style={style.Button}>
              Add
            </Button>
          </div>
        </DialogueOverlay> */}
        <GymNavigation />
        <div style={style.wrapper}>
          <Box outline style={style.box}>
            <Router>
              <Switch>
                <Route
                  exact={true}
                  path="/gyms/gym/amenities/"
                  render={props => (
                    <View {...props} gymAmenities={this.state.gymAmenities} />
                  )}
                />

                <Route
                  path="/gyms/gym/amenities/edit"
                  render={props => (
                    <Edit
                      {...props}
                      gymAmenities={this.state.gymAmenities}
                      deleteAmenitiy={this.deleteAmenitiy}
                      addBtn={this.addBtn}
                    />
                  )}
                />
              </Switch>
            </Router>
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default Amenities;
